import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useState, useEffect } from 'react';
import { Carousel as CarouselZDS } from '@zapier/design-system';
import { mediaQueries, BREAKPOINTS } from '../../constants';
import { labelStyles } from '@zapier/style-encapsulation';
const styles = labelStyles('Carousel', {
    root: css `
    position: relative;
  `,
    overlay: css `
    ${mediaQueries.desktop} {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 423px;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 100%
      );
    }
  `,
});
const useViewportSize = () => {
    const [viewportSize, setViewportSize] = useState({});
    const getViewportSize = () => {
        let width;
        let height;
        if (window.innerWidth >= 0 && window.innerWidth < BREAKPOINTS.extraSmall) {
            width = 'extraSmall';
        }
        else if (window.innerWidth >= BREAKPOINTS.extraSmall &&
            window.innerWidth < BREAKPOINTS.small) {
            width = 'small';
        }
        else if (window.innerWidth >= BREAKPOINTS.small &&
            window.innerWidth < BREAKPOINTS.large) {
            width = 'medium';
        }
        else if (window.innerWidth >= BREAKPOINTS.large &&
            window.innerWidth < BREAKPOINTS.extraLarge) {
            width = 'large';
        }
        else {
            width = 'extraLarge';
        }
        if (innerHeight < 600) {
            height = 'short';
        }
        else {
            height = 'normal';
        }
        setViewportSize((prevState) => {
            if (width !== prevState.width || height !== prevState.height)
                return { width, height };
            return prevState;
        });
    };
    useEffect(() => {
        getViewportSize();
        window.addEventListener('resize', getViewportSize);
        return () => {
            window.removeEventListener('resize', getViewportSize);
        };
    }, []);
    return viewportSize;
};
export const Carousel = ({ children, onActiveSlideChange }) => {
    const { width } = useViewportSize();
    const isMobile = width === 'extraSmall' || width === 'small';
    const slideWidth = isMobile ? 300 : 650;
    const [arrowOffset, setArrowOffset] = useState('50%');
    const [showArrows, setShowArrows] = useState(false);
    const containerRef = (node) => {
        if (!node)
            return;
        const image = node.querySelector('img');
        if (!image) {
            setShowArrows(!isMobile);
            return;
        }
        const handleLoad = () => {
            if (image.clientHeight === 0)
                return;
            setArrowOffset(`${image.clientHeight / 2}px`);
            setShowArrows(!isMobile);
        };
        image.onload = handleLoad;
        image.onerror = () => {
            setShowArrows(!isMobile);
        };
        /** handleLoad is sometimes attached after `onLoad` has already fired.
         *  So, we want to fire it again here and use the early return when image.clientHeight is 0
         *  to avoid the arrows it sliding in from the top.
         */
        handleLoad();
    };
    return (_jsxs("div", Object.assign({ "data-testid": "carousel", ref: containerRef, css: styles.root }, { children: [_jsx(CarouselZDS, Object.assign({ arrowOffset: arrowOffset, onActiveSlideChange: onActiveSlideChange, paginatorStyle: "indicator", showArrows: showArrows, slideWidth: slideWidth }, { children: children })), _jsx("div", { css: styles.overlay })] })));
};
//# sourceMappingURL=Carousel.js.map